import { defaultEndDate, defaultStartDate, getAuditDetailColumns, transformAuditDetails } from './auditData';
import { Api } from '../../api';
import React, { useEffect, useMemo, useState } from 'react';
import { TableDataView } from '../Table/TableDataView';
import Pagination from '../Table/Pagination';
import { compareAsc } from 'date-fns';

async function getAuditEvents(id: string, page, start_date = defaultStartDate, end_date = defaultEndDate) {
  const res = await Api.audit.getUserAuditDetails({ id, start_date, end_date, page });
  const transformedData = transformAuditDetails(res?.data?.audit_data);
  return transformedData.sort(({ amended_date: ld }, { amended_date: rd }) => compareAsc(new Date(ld), new Date(rd)));
}

interface AuditDetailProps {
  id?: string;
  start_date?: string;
  end_date?: string;
}

const UserAuditEvents = ({ id, start_date, end_date }: AuditDetailProps) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [isLastPage, setIsLastPage] = useState(false);
  const [state, setState] = useState([]);

  useEffect(() => {
    getAuditEvents(id, pageNumber, start_date, end_date).then((res) => {
      setState(res);
      setIsLastPage(res.length < 10);
    });
  }, [id, pageNumber, start_date, end_date]);

  const columns = useMemo(() => {
    const item = state[0];
    if (!item) {
      return [];
    }

    return getAuditDetailColumns(item);
  }, [state]);

  return (
    <>
      <TableDataView
        handleTableChange={undefined}
        keyValue={undefined}
        noDataFoundText="No Items Found"
        headerItems={columns as any}
        dataSource={state}
        scroll={{ x: true }}
      />
      <div style={{ paddingBottom: '0.5rem' }}>
        <Pagination
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          isLastPage={isLastPage}
          loading={false}
          setLoading={() => {}}
        />
      </div>
    </>
  );
};

export default UserAuditEvents;
